export enum CompensationType {
  FIXED = 'fixed',
  RANGE = 'range',
}
